// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';
import Hero from './components/Hero';
import About from './components/About';
import TechStack from './components/TechStack';
import Projects from './components/AllProjects';
import Certificates from './pages/Certificates';

import Survey from './pages/projects/Survey';
import Hotel from './pages/projects/Hotel';
import Portfolio from './pages/projects/Portfolio';
import Delivery from './pages/projects/Delivery';
import ScrollToTop from './components/ScrollToTop';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <Hero />
              <About />
              <TechStack />
              <Projects />
              <Certificates />
              <Contact />
              <Footer />
            </Layout>
          }
        />

        <Route path="/projects/survey" element={<Survey />} />
        <Route path="/projects/hotel" element={<Hotel />} />
        <Route path="/projects/portfolio" element={<Portfolio />} />
        <Route path="/projects/delivery" element={<Delivery />} />
      </Routes>
    </Router>
  );
}

export default App;